import PropTypes from 'prop-types';
import React from 'react';
import Link from 'react-router/lib/Link';
import cx from 'classnames';

const CancelButtonLink = ({ content, link, onClick, className }) => (
  <Link to={link} onClick={onClick} className={cx('c-btn c-btn--grey u-width-120 u-mr--', className)}>
    <span className="c-btn__text">{content}</span>
  </Link>
);

CancelButtonLink.propTypes = {
  content: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

CancelButtonLink.defaultProps = {
  onClick: () => null,
  className: '',
};

export default CancelButtonLink;
